/**
 * Which space the edited note lives in. Editor extensions that talk to the
 * outside world (attachment uploads, wikilink completion) read this instead
 * of assuming the personal workspace.
 */
import { Facet } from "@codemirror/state";

export interface EditorSpace {
  spaceId: string;
  shared: boolean;
  /** Item id for attachment ownership and permanent cleanup. */
  noteId?: string;
}

export const editorSpace = Facet.define<EditorSpace, EditorSpace | null>({
  combine: (values) => values[0] ?? null,
});
